module.exports = "../../app/cells/components/cookies_agreement_cell.rb";